import {useContext} from "react";
import {TranslationContext} from "../context/LanguageContext";
import {axiosInstance} from "../axios";

const useTranslation = () => {
    const {translations, language, setAppLanguage, languages} = useContext(TranslationContext);

    const t = (key) => {
        // if (translations && !translations.hasOwnProperty(key)) {
        //     try {
        //         axiosInstance.post('/api/logMissingTranslation', {missingTranslation: key});
        //     } catch (error) {
        //         console.error('Error while saving missing translation:', error);
        //     }
        // }

        return translations?.[key] || key;
    }

    return {t, setAppLanguage, language, languages, translations};
};

export default useTranslation;
